(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33],{

/***/ 6485:
/***/ (function(module) {

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* global DOMException */

module.exports = clipboardCopy

function clipboardCopy (text) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).catch(function (err) {
      throw (err !== undefined ? err : new DOMException('The request is not allowed', 'NotAllowedError'))
    })
  }

  // ...Otherwise, use document.execCommand() fallback

  // Put the text to copy into a <span>
  var span = document.createElement('span')
  span.textContent = text

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre'
  span.style.webkitUserSelect = 'auto'
  span.style.userSelect = 'all'

  // Add the <span> to the page
  document.body.appendChild(span)

  // Make a selection object representing the range of text selected by the user
  var selection = window.getSelection()
  var range = window.document.createRange()
  selection.removeAllRanges()
  range.selectNode(span)
  selection.addRange(range)

  // Copy text to the clipboard
  var success = false
  try {
    success = window.document.execCommand('copy')
  } catch (err) {
    console.log('error', err)
  }

  // Cleanup
  selection.removeAllRanges()
  window.document.body.removeChild(span)

  return success
    ? Promise.resolve()
    : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'))
}


/***/ }),

/***/ 4988:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility/detail/[slug]",
      function () {
        return __webpack_require__(6354);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ CardFaq; },
/* harmony export */   "cO": function() { return /* binding */ CardAuctionDetail; },
/* harmony export */   "dg": function() { return /* binding */ CardFacilityDetail; },
/* harmony export */   "fe": function() { return /* binding */ CardAuction; },
/* harmony export */   "ue": function() { return /* binding */ InfoWindowFacility; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8368);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4357);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8377);
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4532);






var CardAuction = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "flex flex-row items-center space-x-2 w-[15.375rem] min-w-fit",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "min-w-[3.375rem]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: "/images/img-example.png",
                    alt: "",
                    className: "w-[3.375rem] object-cover rounded-xl"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-regular-normal font-medium text-neutral-900 break-all line-clamp-1",
                        children: "Central xxxxx xxxx xxxx"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row items-center space-x-1.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-neutral-900",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "break-all line-clamp-1 text-tiny-none text-neutral-800",
                                children: "Fresno, xxxxx xxxxx xxxx"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CardAuctionDetail = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/facility/detail/".concat(data.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "flex flex-row items-center space-x-2 w-[15.375rem] min-w-fit",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "min-w-[4.25rem]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        src: data.image.md,
                        alt: data.name,
                        className: "w-[4.25rem] object-cover rounded-xl"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col space-y-1.5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-regular-normal font-medium text-neutral-900 break-all line-clamp-1",
                            children: data.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "font-bold text-primary-500 text-small-tight",
                            children: [
                                "#",
                                data.id,
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "font-normal text-neutral-600 capitalize",
                                    children: [
                                        data.type ? data.type === "in_person" ? "in person" : data.type : "Caravan",
                                        " ",
                                        "Auction"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row items-center space-x-1.5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-neutral-900",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .LocationBoldIcon */ .Oi, {
                                        size: "16"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "break-all line-clamp-1 text-tiny-none text-neutral-800",
                                    children: data.address
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var InfoWindowFacility = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white rounded-xl p-3 w-[11.75rem] flex flex-col focus:!outline-none focus-visible:!outline-none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: data.image.lg,
                alt: data.name,
                className: "w-full h-[5.25rem] rounded-lg object-cover"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-medium text-small-normal text-neutral-900 truncate whitespace-normal line-clamp-2 break-all mt-2",
                children: data.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1 font-bold text-primary-500 text-tiny-tight",
                children: [
                    "#",
                    data.id
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-1.5 text-neutral-500 text-tiny-tight",
                children: [
                    data.type ? data.type === "in_person" ? "in person" : data.type : "Caravan",
                    " ",
                    "Auction"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-tiny-normal text-neutral-600 line-clamp-2 break-all mt-1",
                children: data.address
            })
        ]
    });
};
var CardFacilityDetail = function(param) {
    var data = param.data, isBlur = param.isBlur;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative flex flex-row items-center justify-between w-full md:w-[33.438rem] min-w-fit bg-white p-3.5 rounded-xl",
        children: [
            isBlur && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute left-0 bg-white w-full h-full opacity-50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row items-center space-x-3.5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[5.25rem]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            src: data.image.lg,
                            alt: data.unit_number,
                            className: "w-[5.25rem] object-cover rounded-xl"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col space-y-1.5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-regular-none md:text-title3 font-bold text-neutral-900 break-all line-clamp-1",
                                children: [
                                    "#",
                                    data.unit_number
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "font-medium text-neutral-900 text-small-normal",
                                children: "Start this week"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "break-all line-clamp-1 text-tiny-normal md:text-regular-normal text-neutral-600",
                                children: "1,200 watching this auction"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border border-neutral-200 rounded-full p-2 text-primary-500 md:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .SaveAddIcon */ .PF, {
                    size: "16"
                })
            })
        ]
    });
};
var CardFaq = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mx-auto w-full rounded-[0.875rem] bg-white px-3 py-3.5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure */ .p, {
                children: function(param) {
                    var open = param.open;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure.Button */ .p.Button, {
                                className: "flex w-full justify-between space-x-1 text-left text-[1.375rem] leading-6 font-bold text-primary-900 focus:outline-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "break-words line-clamp-2",
                                        children: data.attributes.title
                                    }),
                                    open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .CloseCircleIcon */ .uC, {
                                        className: "text-neutral-500 min-w-[1.5rem]"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* .AddBoldCircleIcon */ .S4, {
                                        className: "text-primary-500 min-w-[1.5rem]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_6__/* .Transition */ .u, {
                                enter: "transition ease duration-500 transform",
                                enterFrom: "opacity-0 -translate-y-12",
                                enterTo: "opacity-100 translate-y-0",
                                leave: "transition ease duration-300 transform",
                                leaveFrom: "opacity-100 translate-y-0",
                                leaveTo: "opacity-0 -translate-y-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Disclosure.Panel */ .p.Panel, {
                                    className: "mt-4.5 text-regular-normal text-neutral-600",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "break-words line-clamp-3",
                                            children: data.attributes.short_description
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: "/faq/".concat(data.attributes.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "font-bold text-primary-500",
                                                children: "Read More..."
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            })
        })
    });
};


/***/ }),

/***/ 6354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./node_modules/use-clipboard-copy/dist/index.js
var dist = __webpack_require__(6248);
// EXTERNAL MODULE: ./app/component/commons/icon/SvgIcon.tsx
var SvgIcon = __webpack_require__(8377);
// EXTERNAL MODULE: ./app/component/commons/image/Image.tsx
var Image = __webpack_require__(4532);
// EXTERNAL MODULE: ./app/component/commons/meta/Meta.tsx
var Meta = __webpack_require__(1817);
// EXTERNAL MODULE: ./app/layouts/DefaultLayout.tsx + 2 modules
var DefaultLayout = __webpack_require__(7213);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
// EXTERNAL MODULE: ./app/component/commons/card/Card.tsx
var Card = __webpack_require__(7268);
// EXTERNAL MODULE: ./app/component/commons/button/Button.tsx
var Button = __webpack_require__(1201);
;// CONCATENATED MODULE: ./app/helpers/EmptyText.tsx

var EmptyText = function(param) {
    var trigger = param.trigger, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: trigger ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-tiny-normal italic font-medium text-neutral-500",
            children: "is empty"
        })
    });
};
/* harmony default export */ var helpers_EmptyText = (EmptyText);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./pages/facility/detail/[slug].tsx














var Index = function(param) {
    var params = param.params;
    var router = (0,next_router.useRouter)();
    var clipboard = (0,dist.useClipboard)();
    var ref = (0,react.useState)(""), mode = ref[0], setMode = ref[1];
    (0,react.useEffect)(function() {
        // window.analytics.page("viewed");
        if (window.innerWidth < 768) {
            setMode("mobile");
        } else {
            setMode("desktop");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
                title: "Storage Unit Auctions Happening At ".concat(params.name, ", ").concat(params.city.name, " | StorageUnitAuctionList.com"),
                description: "Find Storage Unit Auctions happening at ".concat(params.name, " in ").concat(params.city.name, " and every major city and state in the United States. Signup in minutes to get access to the most up to date list of storage unit auctions happening near you."),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "keywords",
                    content: "Storage Unit Auctions At ".concat(params.name, " in ").concat(params.city.name, ", Find Storage Unit Auctions in ").concat(params.city.name, ", Storage Unit Auctions Happening in ").concat(params.city.name)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto mt-7 lg:mt-[5.75rem] lg:px-[10.938rem] px-4.5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col-reverse lg:flex-row lg:space-x-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-7 lg:mt-0 lg:w-7/12 h-[19.25rem] md:h-[24.375rem]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                            className: "rounded-3xl",
                                            title: "Lokasi pada peta",
                                            width: "100%",
                                            height: "100%",
                                            style: {
                                                border: 0
                                            },
                                            loading: "lazy",
                                            allowFullScreen: true,
                                            referrerPolicy: "no-referrer-when-downgrade",
                                            src: "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAocY3PHCXrFWuMvro_jwYfEmc7wb5mJDA", "&q=").concat(params.address, ",").concat(params.zipcode, ",").concat(params.city.name, ",").concat(params.city.state.name, "&region=US")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full lg:w-5/12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row items-start space-x-2.5 ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-12 min-w-[3rem]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: params.image.md,
                                                            alt: params.name,
                                                            className: "w-full h-12 rounded-2lg object-cover"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-regular-normal text-neutral-600 uppercase",
                                                                children: "storage facility"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-large-tight text-neutral-900 font-bold",
                                                                children: params.name
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-3 py-3 border-y border-neutral-200 flex flex-col space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "font-medium text-neutral-900 text-large-normal",
                                                        children: "Location"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row items-center justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-1/3 text-tiny-normal text-neutral-900",
                                                                children: "State & City"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-2/3 text-right text-tiny-normal text-neutral-700",
                                                                children: [
                                                                    params.city.state.name,
                                                                    ", ",
                                                                    params.city.name
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-row items-center justify-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-1/3 text-tiny-normal text-neutral-900",
                                                                children: "Zipcode"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-2/3 text-right text-tiny-normal text-neutral-700",
                                                                children: params.zipcode
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://www.google.com/maps?q=".concat(params.address, ",").concat(params.zipcode, ",").concat(params.city.name, ",").concat(params.city.state.name),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            target: "_blank",
                                                            className: "flex flex-row items-start space-x-2 cursor-pointer",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-12 min-w-[3rem]",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                        src: "/images/map/MapPlaceholder.svg",
                                                                        alt: params.name,
                                                                        className: "w-full h-12 rounded-xl object-cover"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col space-y-2 w-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-tiny-normal text-neutral-600",
                                                                            children: "Located at"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "text-small-normal font-medium text-neutral-900 break-all",
                                                                            children: params.address
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "border-b border-neutral-200 py-3 flex flex-col space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-large-normal font-medium text-neutral-900",
                                                        children: "Contact Information"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "grid grid-cols-1 gap-y-3.5 mt-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-row justify-between space-x-2 items-start",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: params.phone_number ? "tel:+1".concat(params.phone_number) : "#",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex flex-row space-x-2 items-center cursor-pointer",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "p-2.5 bg-info-500 text-white rounded-2lg",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* CallBoldIcon */.l2, {
                                                                                    size: "20"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "flex flex-col space-y-1.5",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "text-tiny-none text-neutral-600 line-clamp-1",
                                                                                        children: "Phone Number"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(helpers_EmptyText, {
                                                                                        trigger: params.phone_number,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "text-regular-tight font-medium text-neutral-900",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* PatternFormat */.HH, {
                                                                                                value: params.phone_number,
                                                                                                displayType: "text",
                                                                                                format: "+1 ### ### ####"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-neutral-500 cursor-pointer ".concat(!params.phone_number ? "hidden" : ""),
                                                                    title: "Copy",
                                                                    onClick: function() {
                                                                        clipboard.copy("+1".concat(params.phone_number));
                                                                        react_toastify_esm/* toast.success */.Am.success("Copied!", {
                                                                            hideProgressBar: true,
                                                                            autoClose: 1000,
                                                                            position: "bottom-center"
                                                                        });
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* CopyBoldIcon */.yg, {
                                                                        size: "19"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        params.upcoming_auctions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-7 md:mt-11 gradient-main min-h-full lg:mx-[10.938rem] p-4.5 md:p-12 lg:rounded-t-[3rem] mx-auto relative flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute lg:right-[-3rem] lg:top-[7rem] top-[-2.5rem] right-[1rem] lg:block hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/box.svg",
                                        alt: "Box",
                                        className: "lg:w-[7.75rem] lg:h-[7.75rem] w-[4.75rem] h-[4.75rem]"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute lg:left-[-4rem] lg:top-[2.5rem] left-[1rem] top-[-1rem] lg:block hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/illustration/01.svg",
                                        alt: "Box",
                                        className: "lg:w-[7.75rem] lg:h-[7.75rem] w-[4.75rem] h-[4.75rem]"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-bold text-neutral-900 text-title3 leading-9 md:!text-title1",
                                    children: "Upcoming Auctions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 md:mt-3.5 text-neutral-700 text-small-normal md:text-large-normal leading-7 text-center md:px-0 px-8",
                                    children: "Signup for a subscription so you don't miss auctions happening at\n              this location"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3.5 md:mt-6 flex flex-col items-center space-y-4.5 md:w-auto w-full",
                                    children: params.upcoming_auctions.map(function(e, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* CardFacilityDetail */.dg, {
                                            data: e,
                                            isBlur: key > 1
                                        }, key);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-[2.375rem] md:mt-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat("https://app.storageunitauctionlist.com", "/b/subscription/add/location?lat=").concat(params.lat, "&lng=").concat(params.lng),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                size: "lg",
                                                className: "!rounded-full w-[10.688rem]",
                                                children: "Subscribe"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Index);


/***/ }),

/***/ 6248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useClipboard = void 0;
var clipboard_copy_1 = __importDefault(__webpack_require__(6485));
var react_1 = __webpack_require__(7294);
var useTimedToggle_1 = __webpack_require__(6778);
function isInputLike(node) {
    return node && (node.nodeName === 'TEXTAREA' || node.nodeName === 'INPUT');
}
function useClipboard(options) {
    if (options === void 0) { options = {}; }
    var _a = useTimedToggle_1.useTimedToggle(false), copied = _a[0], toggleCopied = _a[1];
    var targetRef = react_1.useRef(null);
    var optionsRef = react_1.useRef(options);
    optionsRef.current = options;
    function isSupported() {
        return (!!navigator.clipboard ||
            (typeof document.execCommand === 'function' &&
                typeof document.queryCommandSupported === 'function' &&
                document.queryCommandSupported('copy')));
    }
    var copyHandler = react_1.useCallback(function (text) {
        var opts = optionsRef.current;
        var target = targetRef.current;
        function handleSuccess() {
            if (opts.onSuccess) {
                opts.onSuccess();
            }
            if (opts.copiedTimeout) {
                toggleCopied(opts.copiedTimeout);
            }
            if (opts.selectOnCopy && isInputLike(target)) {
                target.select();
            }
        }
        function handleError() {
            if (opts.onError) {
                opts.onError();
            }
            if (opts.selectOnError !== false && isInputLike(target)) {
                target.select();
            }
        }
        function copy(value) {
            clipboard_copy_1.default(value).then(handleSuccess).catch(handleError);
        }
        if (typeof text === 'string') {
            copy(text);
        }
        else if (target) {
            copy(target.value);
        }
    }, []);
    return {
        copied: copied,
        copy: copyHandler,
        isSupported: isSupported,
        target: targetRef,
    };
}
exports.useClipboard = useClipboard;


/***/ }),

/***/ 6778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTimedToggle = void 0;
var react_1 = __webpack_require__(7294);
function useTimedToggle(initialValue) {
    var _a = react_1.useState(false), value = _a[0], setValue = _a[1];
    var timeoutRef = react_1.useRef();
    var initialValueRef = react_1.useRef(initialValue);
    var toggleValue = function (timeout) {
        clearTimeout(timeoutRef.current);
        setValue(!initialValueRef.current);
        timeoutRef.current = window.setTimeout(function () { return setValue(initialValueRef.current); }, timeout);
    };
    react_1.useEffect(function () { return function () { return clearTimeout(timeoutRef.current); }; }, []);
    return [value, toggleValue];
}
exports.useTimedToggle = useTimedToggle;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [939,506,659,774,888,179], function() { return __webpack_exec__(4988); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);